import React, { useState, useEffect } from "react";
import { Typography, Paper } from "@material-ui/core";
import useStyles from "../../../../styles";
import TotalData from "../TotalData/TotalData";
import TodaysSchedule from "../TodaysSchedule/TodaysSchedule";
import DoubtForum from "../DoubtForum/DoubtForum";
import QuikLinks from "./QuickLinks";
import UpcomingExam from "../UpcomingExam/UpcomingExam";
import RecentOrders from "../RecentOrders/RecentOrders";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import DateCalander from "../../../CustomComponent/DateCalendar"
import { ReactComponent as LearnerIcon } from "../../../images/mainheadingicon/learner.svg"
import { ReactComponent as ExamIcon } from "../../../images/mainheadingicon/exam.svg"
import { ReactComponent as SettingIcon } from "../../../images/mainheadingicon/setting.svg"
import { ReactComponent as BooksIcon } from "../../../images/DashboardIcon/totalbooks.svg";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined';

function Dashboard({ header, globalProfileImageState }) {
  const classes = useStyles();
  // console.log("globalProfileImageState",globalProfileImageState);


  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const [dashboardData, setDashboardData] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  // State specifically for the highlighted calendar dots
  const [highlightDates, setHighlightDates] = useState([]);

  const [liveCenters, setLiveCenters] = useState("");
  const [liveStudents, setLiveStudents] = useState("");
  const [totalLiveStudent,setTotalLiveStudent] = useState("");
  const [totalLiveCenter,setTotalLiveCenter] = useState("");

  // Dashboard component ke andar ye state add karein
  const [isCalendarTableOpen, setIsCalendarTableOpen] = useState(false);

  // Is function ko props ke zariye DateCalander mein bhejna hoga
  const handleCalendarViewChange = (isOpen) => {
    setIsCalendarTableOpen(isOpen);
  };

  const quickLinkData = [
    { label: "Add Learners", link: "/admin/addlearner", icon: <LearnerIcon /> },
    { label: "Add Exam", link: "/admin/addexam", icon: <ExamIcon /> },
    { label: "Feedback Exam", link: "/admin/feedback", icon: <ExamIcon /> },
    { label: "Sync Dashboard", link: "/admin/syncdashboard", icon: <SettingIcon /> },
  ];

  const cards = [

     {
      label: "Total Student",
      value: liveStudents,
      icon: <LearnerIcon />
    },

     {
      label: "Total Server",
      value: liveCenters,
      icon: <MenuBookIcon style={{color:'black'}} />
    },

    {
      label: "Total Live Student",
      value: totalLiveStudent,
      icon: <SchoolOutlinedIcon style={{color:'black'}} />
    },
    {
      label: "Total Live Server",
      value: totalLiveCenter,
      icon: <BooksIcon />
    },

  ]

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/dashbord/client`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );
        console.log(response, "fetchDashboard");
        // Ensure that the API response contains the 'batch' property
        if (response.data) {
          setDashboardData(response.data);
          // 1. Get the array from the response
          const stats = response.data.dashbord || [];

          // 2. Add logic to find "Total Learner" and set it to Live Students
          const learnerObj = stats.find(item => item.title === "Total Live Student");
          if (learnerObj) {
            setLiveStudents(learnerObj.value);
          }

          // 3. Add logic to find "Total Branch" and set it to Live Centers
          const branchObj = stats.find(item => item.title === "Total Center");
          if (branchObj) {
            setLiveCenters(branchObj.value);
          }

          const totalLiveStudentObj = stats.find(item => item.title === "Total Currently Live Student");
          if (totalLiveStudentObj) {
            setTotalLiveStudent(totalLiveStudentObj.value);
          }

          const totalLiveCenterObj = stats.find(item => item.title === "Total Live Center");
          if (totalLiveCenterObj) {
            setTotalLiveCenter(totalLiveCenterObj.value);
          }

          if (response.data.exam_dates) {
            setHighlightDates(response.data.exam_dates);
          }
        } else {
          console.error("Invalid API response format:", response);
        }
      } catch (error) {
        console.error("Error fetching dashbord:", error);
      }
    };

    fetchDashboard();
  }, [decryptedToken]);

  const isDoubtForum = header?.find((data) =>
    data.name === "Doubt Fourm" ? true : false
  );
  const isExam = header?.find((data) => (data.name === "Exam" ? true : false));
  const isMarketing = header?.find((data) =>
    data.name === "Marketing" ? true : false
  );

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1} ${classes.bgskylite} ${classes.pagescroll} ${classes.h89vh}`}>
      <Paper style={{ marginBottom: 20, padding: 10, borderRadius: 16 }}>
        <Typography variant="h6">
          Welcome Back {globalProfileImageState?.name ? globalProfileImageState.name : "User"}
        </Typography>
      </Paper>
      <div className={`${classes.dflex} ${classes.justifyspacebetween}`} style={{ gap: "20px" }}>

        {/* Left Section: Stats Cards */}
        {/* Jab table band ho, tab ye flex: 1 lega taaki cards stretch ho sakein */}
        {!isCalendarTableOpen && (
          <div style={{ flex: 1 }}>
            <TotalData dashboardData={dashboardData?.dashbord} cardData={cards} />
          </div>
        )}

        {/* Right Section: Calendar or Full Table */}
        <div
          style={{
            width: isCalendarTableOpen ? "100%" : "320px",
            transition: "width 0.3s ease",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <DateCalander
            highlightDates={highlightDates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            onViewChange={handleCalendarViewChange}
          />
        </div>
      </div>

      {/* Baaki components niche aayenge */}
      {!isCalendarTableOpen && (
        <>
          <QuikLinks quickLinkData={quickLinkData} />
          <div className={classes.mt2}>
            {isExam && <UpcomingExam dashboardData={dashboardData?.exam} />}
          </div>
        </>
      )}
    </div>
  );
}
export default Dashboard;
